<template>
  <div class="flex-column h100">
    <navbar title="掉标管理"></navbar>
    <div class="dropMark flex1 flex-column h100">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="flex1 flex-column h100">
        <el-tab-pane label="掉标衣物查看" name="first" class="flex1">
          <dropCheck></dropCheck>
        </el-tab-pane>
        <el-tab-pane label="掉标衣物匹配" name="second">
          <dropMatching></dropMatching>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import header from '@/components/header';
import dropCheck from '@/components/dropCheck';
import dropMatching from '@/components/dropMatching';
export default {
  components: {
    navbar: header,
    dropCheck: dropCheck,
    dropMatching: dropMatching
  },
  data() {
    return {
      activeName: 'first'
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'warning-row';
      }
      return '';
    },
  },
}
</script>
<style lang="less" scoped>
@import "../assets/less/view/dropMark.less";
</style>
<style lang="less">
.dropMark {
  .el-card__body {
    overflow-y: scroll;
  }
  .el-tabs__content {
    flex: 1;
    display: flex;
    .el-tab-pane {
      flex: 1;
      display: flex;
    }
  }
}
</style>